import { render } from "./PurchaseTableAccountant.vue?vue&type=template&id=402b820f"
import script from "./PurchaseTableAccountant.vue?vue&type=script&lang=js"
export * from "./PurchaseTableAccountant.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__